import SearchBarServices from './SearchBarServices'
import { ServiceData } from '../types/types'

type Props = {
  servicesData: ServiceData[]
}

function SearchInlay({servicesData}: Props) {
  const heading = CD_STATE?.searchTextContent?.heading?.trim()
  const subheading = CD_STATE?.searchTextContent?.subheading?.trim()

  return (
    <>
      {heading && (
        <div className='text-5xl md:text-8xl font-bstSpyre mt-[60px] md-max:px-[30px] text-center'>
          {heading}
        </div>
      )}
      {subheading && (
        <div className='text-base-2 font-bstSpyre tracking-[0.56px] mt-XS text-center md-max:px-[30px]'>
          {subheading}
        </div>
      )}
      <SearchBarServices servicesData={servicesData} />
    </>
  )
}

export default SearchInlay